import React from "react";
import LandingPageWrapper from "./LandingPageWrapper";
import LoginForm from "@/components/auth/LoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

export enum LandingPageTab {
  LOGIN = "login",
  FORGOT = "forgot",
}
function LandingPage() {
  const [tab, setTab] = React.useState(LandingPageTab.LOGIN);
  return (
    <LandingPageWrapper>
      {tab === LandingPageTab.LOGIN ? (
        <LoginForm setTab={setTab} />
      ) : (
        <ForgotPasswordForm setTab={setTab} />
      )}
    </LandingPageWrapper>
  );
}

export default LandingPage;
